import { makeAutoObservable } from "mobx";
import { NodeId } from "./node";

/**
 * Пропуск на запись результата загрузки.
 *
 * Выдаётся в момент выбора узла и предъявляется перед тем, как положить
 * что-либо в форму. Просроченный пропуск означает, что пользователь уже выбрал
 * другой узел либо перевыбрал этот же, и результат нужно выбросить.
 */
export type SelectionToken = {
  generation: number;
  id: NodeId | null;
};

/**
 * Текущий выбор в дереве.
 *
 * Заменяет два счётчика v2 (`selectionGeneration` и `loadCounter`): оба решали
 * одну задачу — «не дать позднему ответу перезаписать актуальный экран».
 * Повторный выбор того же узла тоже поднимает поколение, поэтому случай
 * «тот же узел, новая загрузка» покрыт тем же механизмом.
 *
 * Про дерево store не знает: очисткой выбора при удалении узла занимается тот,
 * кто удаляет, — у него есть и дерево, и выбор.
 */
export class SelectionStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedId: NodeId | null = null;

  private generation = 0;

  /** Выбрать узел. Прежние незавершённые загрузки становятся неактуальными. */
  select(id: NodeId | null): SelectionToken {
    this.generation += 1;
    this.selectedId = id;
    return this.token;
  }

  get token(): SelectionToken {
    return { generation: this.generation, id: this.selectedId };
  }

  isActual(token: SelectionToken): boolean {
    return token.generation === this.generation;
  }
}
